import type { BookingState, ViewId } from "@/types";

/** Estado mutable de la SPA (asistente de reserva + filtros). */
export interface AppState {
  booking: BookingState;
  step: number;
  activeCat: string;
  view: ViewId;
}

function emptyBooking(): BookingState {
  return { service: null, date: null, time: null, name: "", phone: "", note: "" };
}

export const state: AppState = {
  booking: emptyBooking(),
  step: 1,
  activeCat: "Uñas",
  view: "inicio",
};

export function resetBooking(): void {
  state.booking = emptyBooking();
}
